import Button from "../../../independent/Button";
import Confirm from "./Confirm";


const DisplayModeButtons = ({ closeModal, closeSubModal, subModalMount, handleDeleteHistory, handleLoadDesign}) => {

  return (
    <div className={"display-mode-buttons"}>
      <Button name={"DELETE"}
              className={"notheme"}
              confirm={true}
              onClick={() => {
                subModalMount(
                  <Confirm closeSubModal={closeSubModal}
                           closeModal={closeModal}
                           title={"Delete History"}
                           message={"Do you want to delete this history?"}
                           callback={() => {
                             handleDeleteHistory(closeModal, closeSubModal, subModalMount);
                           }}
                  />, false);
              }}
      />
      <Button name={"LOAD DESIGN"}
              className={"notheme"}
              onClick={handleLoadDesign}
      />
    </div>
  )
}

export default DisplayModeButtons;
